import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Home from "./Home";
import Book from "./Book";

const Allpages = () => {
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    setIsAuthenticated(!!token);

    const interests = JSON.parse(localStorage.getItem("selectedInterests") || "[]");
    setSelectedInterests(interests);
    
    console.log("User authenticated:", !!token);
    console.log("Selected interests:", interests);
    
    setIsLoading(false);
  }, []);

  const shouldShowContent = (contentCategory) => {
    if (selectedInterests.includes("All")) {
      return true;
    }
    
    if (selectedInterests.length === 0) {
      return false;
    }
    
    return selectedInterests.includes(contentCategory);
  };

  if (isLoading) {
    return <div style={{ padding: "50px", textAlign: "center" }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Remove interests check - admin config controls what users see
  // Normal users don't need to select interests anymore

  return (
    <div className="allpages-container">
      <div className="pages-sequence">
        {/* Home section - Always show */}
        <Home />

        {/* Book section with filtering */}
        <Book selectedInterests={selectedInterests} shouldShowContent={shouldShowContent} />

      </div>
    </div>
  );
};

export default Allpages;